import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, Optional, NgModule } from '@angular/core';
import { ModalService } from '@mt-ng2/modal-module';
import { KeyboardShortcutService, NgxKeyboardShortcutModule } from 'ngx-keyboard-shortcuts';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-keyboard-shortcuts';
import * as ɵngcc2 from '@mt-ng2/modal-module';
export * from 'ngx-keyboard-shortcuts';
import { defaultModuleConfig, KeyboardShortcutsModuleConfigToken } from '@mt-ng2/keyboard-shortcuts-module-config';
import { CommonModule } from '@angular/common';

class KeyboardShortcutHelpWindowService {
    constructor(keyboardShortcutsService, modalService, moduleConfig) {
        this.keyboardShortcutsService = keyboardShortcutsService;
        this.modalService = modalService;
        this.moduleConfig = moduleConfig;
        this.options = {
            html: '',
            showCancelButton: false,
            showCloseButton: false,
            showConfirmButton: false,
            title: 'Keyboard Shortcuts',
        };
        this.setModuleConfig(moduleConfig);
    }
    setModuleConfig(moduleConfig) {
        this.moduleConfig = Object.assign({}, defaultModuleConfig, this.moduleConfig);
        this.keyboardShortcutsService.listen({
            description: 'display this help window',
            handler: this.showHelpWindow.bind(this),
            keyBinding: this.moduleConfig.helpKeyBinding,
        });
    }
    showHelpWindow() {
        this.options.html = this.buildHtml();
        this.modalService.showModal(this.options).subscribe();
    }
    buildHtml() {
        let html = `
        <br/>
        <div style="text-align: left; margin-left: 30px;">
        `;
        const shortcutsToShow = this.keyboardShortcutsService.listeners_read_only;
        shortcutsToShow.forEach((s) => {
            html += `
            <div style="margin-bottom: 25px"><strong class="well well-sm">${s.displayShortcutCombination}</strong><span style="margin-left: 15px">${s.description}</span></div>
            `;
        });
        html += `
        </div>
        <br/>
        `;
        return html;
    }
}
KeyboardShortcutHelpWindowService.ɵfac = function KeyboardShortcutHelpWindowService_Factory(t) { return new (t || KeyboardShortcutHelpWindowService)(ɵngcc0.ɵɵinject(ɵngcc1.KeyboardShortcutService), ɵngcc0.ɵɵinject(ɵngcc2.ModalService), ɵngcc0.ɵɵinject(KeyboardShortcutsModuleConfigToken, 8)); };
KeyboardShortcutHelpWindowService.ɵprov = ɵɵdefineInjectable({ factory: function KeyboardShortcutHelpWindowService_Factory() { return new KeyboardShortcutHelpWindowService(ɵɵinject(KeyboardShortcutService), ɵɵinject(ModalService), ɵɵinject(KeyboardShortcutsModuleConfigToken, 8)); }, token: KeyboardShortcutHelpWindowService, providedIn: "root" });
KeyboardShortcutHelpWindowService.ctorParameters = () => [
    { type: KeyboardShortcutService },
    { type: ModalService },
    { type: undefined, decorators: [{ type: Inject, args: [KeyboardShortcutsModuleConfigToken,] }, { type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(KeyboardShortcutHelpWindowService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.KeyboardShortcutService }, { type: ɵngcc2.ModalService }, { type: undefined, decorators: [{
                type: Inject,
                args: [KeyboardShortcutsModuleConfigToken]
            }, {
                type: Optional
            }] }]; }, null); })();

class KeyboardShortcutModule {
}
KeyboardShortcutModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: KeyboardShortcutModule });
KeyboardShortcutModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function KeyboardShortcutModule_Factory(t) { return new (t || KeyboardShortcutModule)(); }, imports: [[CommonModule, NgxKeyboardShortcutModule], NgxKeyboardShortcutModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(KeyboardShortcutModule, { imports: function () { return [CommonModule, NgxKeyboardShortcutModule]; }, exports: function () { return [NgxKeyboardShortcutModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(KeyboardShortcutModule, [{
        type: NgModule,
        args: [{
                exports: [NgxKeyboardShortcutModule],
                imports: [CommonModule, NgxKeyboardShortcutModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { KeyboardShortcutHelpWindowService, KeyboardShortcutModule };

//# sourceMappingURL=mt-ng2-keyboard-shortcuts-module.js.map